import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What does 'attorney-led' mean for my transaction?",
      answer: "Every file at American Legal Abstract benefits from attorney oversight. This means complex legal issues are identified and resolved proactively, title defects are addressed with sophisticated solutions, and you have direct access to legal expertise when unusual situations arise. Our attorneys don't just review paperwork. They actively guide each transaction to a successful close.",
    },
    {
      question: "Which states are you licensed in?",
      answer: "We are fully licensed and actively closing transactions in Pennsylvania, New Jersey, New York, and Florida. Our 30 years of experience spans all four states, giving us deep knowledge of state-specific requirements and local practices.",
    },
    {
      question: "How do your underwriter relationships benefit me?",
      answer: "Our direct relationships with First American and Fidelity, two of the world's largest title insurers, mean we can often secure exceptions and approvals that other agencies cannot. For example, we can frequently insure over aged mortgages or resolve unusual title matters through direct underwriter communication, saving time and keeping your deals on track.",
    },
    {
      question: "What are my closing options?",
      answer: "We offer complete flexibility: Remote Online Notarization (RON) for anywhere closings, on-site closings at the property or location of your choice, fully remote electronic closings, and traditional in-office closings at any of our locations. We work around your schedule and preferences.",
    },
    {
      question: "How do you prevent wire fraud?",
      answer: "We employ multiple layers of protection: encrypted file platforms, rigorous seller identity verification, verbal confirmation protocols for all wire instructions, and strict adherence to ALTA best practices. We never send wire instructions via email alone and always verify through secure, authenticated channels.",
    },
    {
      question: "What types of transactions do you handle?",
      answer: "We handle everything from straightforward residential purchases and refinances to complex commercial transactions, multi-party deals, properties with unusual title issues, luxury/high-value properties, and family law property transfers. Our attorney-led model is particularly valuable for complex situations that require sophisticated problem-solving.",
    },
  ];

  return (
    <section id="faq" className="py-24 lg:py-32 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-xs font-bold uppercase tracking-widest text-[#B45309] mb-4">FAQ</p>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#0F172A] tracking-tight mb-6">
            Common Questions
          </h2>
          <p className="text-lg text-[#64748B] leading-relaxed">
            Everything you need to know about working with American Legal Abstract.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-[#E7E5E4] bg-[#FAFAF9]"
              data-testid={`faq-item-${index}`}
            >
              <button
                className="w-full flex items-center justify-between p-6 text-left"
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                data-testid={`faq-button-${index}`}
              >
                <span className="font-serif text-lg font-medium text-[#0F172A] pr-4">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-[#64748B] flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                  strokeWidth={1.5}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-[#64748B] leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
